import { paths } from '@luxuryescapes/contract-business'
import type { ItemPolicyBudgetWire } from 'businessTraveller/types/itemPolicyBudget.types'

type ItemPolicyCalculatedCreditsResponseWire = paths['/api/business-traveller/businesses/{businessId}/item-policies/calculate']['post']['responses'][200]['content']['application/json']['result']
type ItemPolicyCalculatedCreditsRowWire = ItemPolicyCalculatedCreditsResponseWire[string][number]
type ItemPolicyBudgetRowWire = ItemPolicyBudgetWire['rowsByEmployee'][number]

export function mapItemPolicyEvaluationRow(
  row: ItemPolicyCalculatedCreditsRowWire | ItemPolicyBudgetRowWire,
): App.BusinessTraveller.ItemPolicyEvaluationRow {
  return {
    employeeId: row.employeeId,
    verdict: row.verdict,
    itemPolicyId: row.itemPolicyId,
    policyName: row.policyName,
    applicableBudget: row.applicableBudget,
    currencyCode: row.currencyCode,
    decisionSource: row.decisionSource,
    budgetComparisonPercent: 'budgetComparisonPercent' in row ? row.budgetComparisonPercent : null,
    creditValue: 'creditValue' in row ? row.creditValue : 0,
    budgetCompliance: row.budgetCompliance,
  }
}

export function mapItemPolicyBudgetResult(result: ItemPolicyBudgetWire): App.BusinessTraveller.ItemPolicyBudgetResult {
  return {
    itemPolicyType: result.itemPolicyType,
    currencyCode: result.currencyCode,
    rowsByEmployee: result.rowsByEmployee.map(mapItemPolicyEvaluationRow),
    travellers: result.travellers.map(traveller => ({
      employeeId: traveller.employeeId,
      hasPolicy: traveller.hasPolicy,
      perNightPerRoom: 'perNightPerRoom' in traveller ? traveller.perNightPerRoom : null,
      perRoomAmount: 'perRoomAmount' in traveller ? traveller.perRoomAmount : null,
      perLeg: 'perLeg' in traveller ? traveller.perLeg : null,
      currencyCode: traveller.currencyCode,
      policyName: traveller.policyName,
    })),
    summary: { ...result.summary },
  } as App.BusinessTraveller.ItemPolicyBudgetResult
}

export function mapItemPolicyCalculatedCreditsResponse(
  serverData: ItemPolicyCalculatedCreditsResponseWire,
): Record<string, App.BusinessTraveller.ItemPolicyCalculatedCreditsResult> {
  return Object.fromEntries(
    Object.entries(serverData).map(([key, rows]) => [
      key,
      { rowsByEmployee: rows.map(mapItemPolicyEvaluationRow) },
    ]),
  )
}
